'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — real estate buyer experience operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Buyer sentiment pulse',
  kpis: [
    { val: '820', lbl: 'Live mentions', live: true },
    { val: '64', lbl: 'Open escalations' },
    { val: '4.8m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 35, tone: 'positive' },
    { lbl: 'Neutral', pct: 35, tone: 'neutral' },
    { lbl: 'Negative', pct: 30, tone: 'negative' },
  ],
  sla: { pct: 73, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'R', text: 'Possession delayed by a year', handle: '@rajiv_m', tag: 'Possession', tagLevel: 'high' },
    { letter: 'S', text: 'Hidden charges at booking', handle: '@swati_k', tag: 'Billing', tagLevel: 'med' },
    { letter: 'A', text: 'Maintenance ignored for weeks', handle: '@anil_d', tag: 'Service', tagLevel: 'med' },
    { letter: 'P', text: 'Refund stuck after cancellation', handle: '@pooja_n', tag: 'Refund', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Buyer risk', sub: 'Possession complaints clustering' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Case → CRM team in 2s' },
  ],
};

export default function RealEstateHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Real Estate'),
      }}
      title={
        <>
          {t('industries_real_estate.a_buyers_first_complaint_online_is')}{' '}
          <span className="serif-accent italic">{t('industries_real_estate.real_estate_developer_brand_reputat')}</span>
          {' '}{t('industries_real_estate.for')}{' '}
          <span className="serif-accent italic">{t('industries_real_estate.developers_brokers_proptech_brands')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_real_estate.todays_homebuyers_are_more_informed')}{' '}
          <span style={BLUE}>{t('industries_real_estate.possession_delay_complaint')}</span> {t('industries_real_estate.posted_publicly_reaches_thousands_o')}{' '}
          <span style={DEEP}>{t('industries_real_estate.locobuzz_protects_it')}</span>
        </>
      }
      actions={
        <BookDemoButton label={t('industries_real_estate.book_a_personalised_real_estate_bra')} />
      }
      visual={<IndustryCommandCentre ariaLabel="Real estate buyer experience command centre" {...CC} />}
    />
  );
}
